import { AtomicBlockUtils, EditorState, Modifier, SelectionState } from 'draft-js';
import { Children, Component } from 'react';

import ImageResizer from './ImageResizer';

class ImageDecorator extends Component {
  state = {};

  getEntityData() {
    const { contentState, entityKey } = this.props;
    return contentState.getEntity(entityKey).getData();
  }

  updateSize = (width, height) => {
    this.updateEntityData({ width, height });
  };
  updateEntityData = data => {
    const { entityKey, getEditorState, setEditorState } = this.props;
    const editorState = getEditorState();
    const updatedContentState = editorState.getCurrentContent().mergeEntityData(entityKey, data);
    setEditorState(EditorState.push(editorState, updatedContentState, 'apply-entity'), true);
  };

  componentWillUnmount() {
    if (this.state.active) {
      this.props.setReadOnly(false);
      this.props.setActiveInlineImage?.(null);
    }
  }

  setActive = e => {
    this.setState({ active: true });
    this.props.setReadOnly(true);
    this.props.setActiveInlineImage?.({ convert: this.convertToBlock });
    e.stopPropagation(); // otherwise gets captured by ImageResizer clickAway and immediately closes
  };

  setInactive = () => {
    this.setState({ active: false });
    this.props.setReadOnly(false);
    this.props.setActiveInlineImage?.(null);
  };

  convertToBlock = () => {
    const { entityKey, getEditorState, setEditorState } = this.props;
    const editorState = getEditorState();
    const contentState = editorState.getCurrentContent();
    const entityData = contentState.getEntity(entityKey).getData();

    const [blockKey, offset] = this.getBlockAndOffset();

    let newContentState = Modifier.removeRange(
      contentState,
      SelectionState.createEmpty(blockKey).merge({ anchorOffset: offset, focusOffset: offset + 1 }),
      'backward',
    );

    newContentState = newContentState.createEntity('IMAGE', 'IMMUTABLE', entityData);
    const newEntityKey = newContentState.getLastCreatedEntityKey();

    let newEditorState = EditorState.push(editorState, newContentState, 'remove-range');
    newEditorState = AtomicBlockUtils.insertAtomicBlock(newEditorState, newEntityKey, ' ');

    this.setInactive();
    setEditorState(newEditorState);
    this.props.onResetFocus();
  };

  handleDelete = () => {
    const { getEditorState, setEditorState } = this.props;
    const [blockKey, offset] = this.getBlockAndOffset();
    const updatedContentState = Modifier.removeRange(
      getEditorState().getCurrentContent(),
      SelectionState.createEmpty(blockKey).merge({ anchorOffset: offset, focusOffset: offset + 1 }),
      'backward',
    );
    this.setInactive();
    setEditorState(EditorState.push(getEditorState(), updatedContentState, 'remove-range'));
  };

  getBlockAndOffset() {
    const { children, offsetKey } = this.props;
    const blockKey = offsetKey.split('-')[0];
    // eslint-disable-next-line @eslint-react/no-children-map
    const offset = Children.map(children, c => c.props.start)[0];
    return [blockKey, offset];

    // return Selection.createEmpty(blockKey).merge({ anchorOffset: offset, focusOffset: offset})
  }

  render() {
    const { children, readOnly } = this.props;
    const { alt, height, id, url, width } = this.getEntityData();
    const { active } = this.state;
    return (
      <span css={rootCss} onMouseDown={readOnly || active ? undefined : this.setActive}>
        {active ?
          <ImageResizer
            height={height}
            maxWidthParentSelector=".DraftEditor-root"
            onDelete={this.handleDelete}
            onResizeComplete={this.updateSize}
            onUnselectImage={this.setInactive}
            url={url}
            width={width}
          />
        : <>
            <img
              key={id}
              alt={alt}
              className="ID-img"
              height={height}
              onLoad={
                !readOnly && !(width && height) ?
                  e => this.updateEntityData({ width: e.target.naturalWidth, height: e.target.naturalHeight })
                : undefined
              }
              src={url}
              style={{ width }}
              width={width}
            />
            {children}
          </>
        }
      </span>
    );
  }
}

const rootCss = ({ palette }) => ({
  display: 'inline-block',
  lineHeight: 0,
  '& > span': {
    display: 'inline-block',
    width: 0,
  },
  '.ID-img': {
    userSelect: 'none',
    maxWidth: '100%',
    height: 'auto',
    ...(palette.mode === 'dark' && { filter: 'invert(100%) hue-rotate(180deg)' }),
  },
});

export default {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'IMAGE';
    }, callback);
  },
  component: ImageDecorator,
};
